/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ImageVersionTypeName = "large" | "master" | "medium" | "original" | "placeholder" | "small" | "thumb" | "zoom" | "%future added value";
export type PdpHead_item$ref = any;
export type PdpHead_item = {
    readonly microdata: string | null;
    readonly pdpURL: string | null;
    readonly localizedPdpUrl: string | null;
    readonly pdpMeta: {
        readonly title: string | null;
        readonly description: string | null;
        readonly ogTitle: string | null;
        readonly productPriceAmount: string | null;
        readonly productPriceCurrency: string | null;
    } | null;
    readonly photos: ReadonlyArray<{
        readonly versions: ReadonlyArray<{
            readonly webPath: string | null;
            readonly type: {
                readonly name: ImageVersionTypeName | null;
            } | null;
        } | null> | null;
    } | null> | null;
    readonly isListingNotListed: boolean | null;
    readonly isMissingTranslatedItemTitle: boolean | null;
    readonly isPriceUponRequest: boolean | null;
    readonly seller: {
        readonly isInternal: boolean | null;
    } | null;
    readonly isSold: boolean | null;
    readonly metrics: ReadonlyArray<{
        readonly value: string | null;
    } | null> | null;
    readonly " $refType": PdpHead_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpHead_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "forcedCurrency",
      "type": "Currency"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "microdata",
      "args": [
        {
          "kind": "Variable",
          "name": "currency",
          "variableName": "forcedCurrency"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pdpURL",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedPdpUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pdpMeta",
      "storageKey": null,
      "args": null,
      "concreteType": "pdpMetaItems",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "title",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "ogTitle",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "productPriceAmount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "productPriceCurrency",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "photos",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "versions",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "webPath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "type",
              "storageKey": null,
              "args": null,
              "concreteType": "ImageVersionType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isListingNotListed",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isMissingTranslatedItemTitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isPriceUponRequest",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isInternal",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isSold",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "metrics",
      "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")",
      "args": [
        {
          "kind": "Literal",
          "name": "metricTypes",
          "value": [
            "LISTING_VIEWS"
          ]
        },
        {
          "kind": "Literal",
          "name": "timeRange",
          "value": "LAST_6_MONTHS"
        }
      ],
      "concreteType": "MetricDetailType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "value",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '806682c0bb05fbb48298a68d289a452c';
export default node;
